<app-hero
	[title]="'menu.help' | translate"
	imageDesktop="assets/hero/assistenza.jpg"
	imageMobile="assets/hero/assistenza_mobile.png"
/>

<div class="container-xxl mh-500 help-container">
	<!-- <div class="help-header">
		<p class="help-subtitle"></p>
	</div> -->
	<mat-accordion>
		<!-- AUCTION -->
		<mat-expansion-panel class="main-accordion">
			<mat-expansion-panel-header>
				<mat-panel-title class="section-title">{{ "support.auction.title" | translate }}</mat-panel-title>
			</mat-expansion-panel-header>

			<div class="submenu-container">
				<mat-accordion>
					<!-- HOW TO OFFER -->
					<mat-expansion-panel class="main-accordion">
						<mat-expansion-panel-header>
							<mat-panel-title class="section-subtitle">
								{{ "support.auction.howToOffer" | translate }}
							</mat-panel-title>
						</mat-expansion-panel-header>

						<div class="panel-content">
							<ol class="help-list">
								<li class="help-text">1. {{ "come-fare-una-offerta.p1" | translate }}</li>
								<li class="help-text">2. {{ "come-fare-una-offerta.p2" | translate }}</li>

								<li class="help-text icon-line">
									3. {{ "come-fare-una-offerta.p3" | translate }}
									<div class="icon-observe d-inline-block align-middle"></div>
								</li>

								<li class="help-text">4. {{ "come-fare-una-offerta.p4" | translate }}</li>
								<li class="help-text">5. {{ "come-fare-una-offerta.p5" | translate }}</li>
								<li class="help-text">6. {{ "come-fare-una-offerta.p6" | translate }}</li>
							</ol>

							<div class="bid-status">
								<div class="status-item">
									<span class="badge red text-uppercase">{{ "color.red" | translate }}</span>
									{{ "come-fare-una-offerta.p7" | translate }}
								</div>

								<div class="status-item">
									<span class="badge yellow text-uppercase">{{ "color.yellow" | translate }}</span>
									{{ "come-fare-una-offerta.p8" | translate }}
								</div>

								<div class="status-item">
									<span class="badge green text-uppercase">{{ "color.green" | translate }}</span>
									{{ "come-fare-una-offerta.p9" | translate }}
								</div>
							</div>
						</div>
					</mat-expansion-panel>

					<!-- EXTRA TIME -->
					<mat-expansion-panel class="main-accordion">
						<mat-expansion-panel-header>
							<mat-panel-title class="section-subtitle">
								{{ "support.auction.howExtraTime" | translate }}
							</mat-panel-title>
						</mat-expansion-panel-header>

						<div class="panel-content">
							<p class="help-text">{{ "come-funziona-extratime.p1" | translate }}</p>
							<p class="help-text">{{ "come-funziona-extratime.p2" | translate }}</p>
							<br />
							<p class="help-text">{{ "come-funziona-extratime.p3" | translate }}</p>
							<p class="help-text">{{ "come-funziona-extratime.p4" | translate }}</p>
							<p class="help-text">{{ "come-funziona-extratime.p5" | translate }}</p>
							<p class="help-text">{{ "come-funziona-extratime.p6" | translate }}</p>
							<p class="help-text">{{ "come-funziona-extratime.p7" | translate }}</p>
							<p class="help-text">{{ "come-funziona-extratime.p8" | translate }}</p>
						</div>
					</mat-expansion-panel>

					<!-- AUTOMATIC RELAUNCH -->
					<mat-expansion-panel class="main-accordion">
						<mat-expansion-panel-header>
							<mat-panel-title class="section-subtitle">
								{{ "support.auction.automaticRelaunch" | translate }}
							</mat-panel-title>
						</mat-expansion-panel-header>

						<div class="panel-content">
							<p class="help-text">{{ "rilancio-automatico.p1" | translate }}</p>
							<br />
							<p class="help-text">
								<strong>{{ "rilancio-automatico.p2" | translate }}</strong>
							</p>

							<p class="help-text">{{ "rilancio-automatico.p3" | translate }}</p>
							<p class="help-text">{{ "rilancio-automatico.p4" | translate }}</p>
							<p class="help-text">{{ "rilancio-automatico.p5" | translate }}</p>
							<p class="help-text">{{ "rilancio-automatico.p6" | translate }}</p>
							<br />
							<p class="help-text">{{ "rilancio-automatico.p7" | translate }}</p>
							<p class="help-text">{{ "rilancio-automatico.p8" | translate }}</p>
							<p class="help-text">{{ "rilancio-automatico.p9" | translate }}</p>
							<p class="help-text">{{ "rilancio-automatico.p10" | translate }}</p>
							<p class="help-text">{{ "rilancio-automatico.p11" | translate }}</p>
						</div>
					</mat-expansion-panel>

					<!-- AUCTION TYPES -->
					<mat-expansion-panel class="main-accordion">
						<mat-expansion-panel-header>
							<mat-panel-title class="section-subtitle">
								{{ "support.auction.auctionTypes" | translate }}
							</mat-panel-title>
						</mat-expansion-panel-header>

						<div class="panel-content">
							<p class="help-text">
								<strong>{{ "diversi-tipi-di-aste.p1" | translate }}</strong>
							</p>

							<ul class="help-list">
								<li class="help-text">{{ "diversi-tipi-di-aste.p2" | translate }}</li>
							</ul>
							<br />
							@if (utils.getMarket() !== "LU") {
								<p class="help-text">
									<strong>{{ "diversi-tipi-di-aste.p3" | translate }}</strong>
								</p>
								<ul class="help-list">
									<li class="help-text">{{ "diversi-tipi-di-aste.p4" | translate }}</li>
								</ul>
								<br />
							}
							<p class="help-text">
								<strong>{{ "diversi-tipi-di-aste.p5" | translate }}</strong>
							</p>

							<p class="help-text">{{ "diversi-tipi-di-aste.p6" | translate }}</p>
							<p class="help-text">{{ "diversi-tipi-di-aste.p7" | translate }}</p>
							<br />
							<p class="help-text">
								<strong>{{ "diversi-tipi-di-aste.p8" | translate }}</strong>
							</p>

							<p class="help-text">{{ "diversi-tipi-di-aste.p9" | translate }}</p>
							<p class="help-text">{{ "diversi-tipi-di-aste.p10" | translate }}</p>
						</div>
					</mat-expansion-panel>

					<!-- CONDITIONS -->
					<mat-expansion-panel class="main-accordion">
						<mat-expansion-panel-header>
							<mat-panel-title class="section-subtitle">
								{{ "support.auction.conditionsUses" | translate }}
							</mat-panel-title>
						</mat-expansion-panel-header>

						<p class="help-text">
							{{ "condizioni-di-uso.p1" | translate }}
						</p>
					</mat-expansion-panel>
				</mat-accordion>
			</div>
		</mat-expansion-panel>

		<!-- SHOWCASE -->
		@if (["FR", "DE", "PT"].includes(utils.getMarket())) {
			<mat-expansion-panel class="main-accordion">
				<mat-expansion-panel-header class="section-title">
					<mat-panel-title class="section-title">
						{{ "support.showcase.title" | translate }}
					</mat-panel-title>
				</mat-expansion-panel-header>
				<div class="submenu-container">
					<mat-expansion-panel class="main-accordion">
						<mat-expansion-panel-header class="section-subtitle">
							<mat-panel-title class="section-subtitle">
								{{ "support.showcase.howToBook" | translate }}
							</mat-panel-title>
						</mat-expansion-panel-header>

						<div class="panel-content">
							<p class="help-text">
								<strong>{{ "come-prenotare.p1" | translate }}</strong>
							</p>

							<ul class="help-list">
								<li class="help-text">{{ "come-prenotare.p2" | translate }}</li>
								<li class="help-text">{{ "come-prenotare.p3" | translate }}</li>
								<li class="help-text">{{ "come-prenotare.p4" | translate }}</li>
								<li class="help-text">{{ "come-prenotare.p5" | translate }}</li>
							</ul>
							<br />
							<p class="help-text">
								<strong>{{ "come-prenotare.p6" | translate }}</strong>
							</p>

							<p class="help-text">{{ "come-prenotare.p7" | translate }}</p>
							<p class="help-text">{{ "come-prenotare.p8" | translate }}</p>
							<p class="help-text">{{ "come-prenotare.p9" | translate }}</p>
							<p class="help-text">{{ "come-prenotare.p10" | translate }}</p>
							<br />
							<p class="help-text">
								<strong>{{ "come-prenotare.p11" | translate }}</strong>
							</p>

							<p class="help-text">{{ "come-prenotare.p12" | translate }}</p>
							<br />
							<p class="help-text">
								<strong>{{ "come-prenotare.p13" | translate }}</strong>
							</p>

							<p class="help-text">{{ "come-prenotare.p14" | translate }}</p>
							<p class="help-text">{{ "come-prenotare.p15" | translate }}</p>
						</div>
					</mat-expansion-panel>

					<mat-expansion-panel class="main-accordion">
						<mat-expansion-panel-header class="section-subtitle">
							<mat-panel-title class="section-subtitle">
								{{ "support.showcase.conditionUses" | translate }}
							</mat-panel-title>
						</mat-expansion-panel-header>

						<p class="help-text">
							{{ "vetrine-condizioni-di-uso.p1" | translate }}
						</p>
					</mat-expansion-panel>
				</div>
			</mat-expansion-panel>
		}

		<mat-expansion-panel class="main-accordion">
			<mat-expansion-panel-header class="section-title">
				<mat-panel-title class="section-title">
					{{ "support.awardAndPurchase.title" | translate }}
				</mat-panel-title>
			</mat-expansion-panel-header>

			<p class="help-text">
				<strong>{{ "award-and-purchase.p1" | translate }}</strong>
			</p>
			<p class="help-text">{{ "award-and-purchase.p2" | translate }}</p>
			<br />
			<p class="help-text">
				<strong>{{ "award-and-purchase.p3" | translate }}</strong>
			</p>
			<p class="help-text">{{ "award-and-purchase.p4" | translate }}</p>
		</mat-expansion-panel>

		<!-- @if (!["DE", "AT", "BE"].includes(utils.getMarket())) { -->
		@if (utils.getMarket() === "IT") {
			<mat-expansion-panel class="main-accordion">
				<mat-expansion-panel-header class="section-title">
					<mat-panel-title class="section-title">
						{{ "support.postBuy.title" | translate }}
					</mat-panel-title>
				</mat-expansion-panel-header>
				<!-- <p class="help-text">
					<strong>{{ "bolli-pratiche.p1" | translate }}</strong>
				</p>
				<p class="help-text">{{ "bolli-pratiche.p2" | translate }}</p>
				<a
					class="ck-link p-0"
					(click)="openBooklet()"
				>
					{{ "bolli-pratiche.p6" | translate }}
				</a>
				<p class="help-text">{{ "bolli-pratiche.p3" | translate }}</p>
				<a
					class="ck-link p-0"
					href="https://easydrive.fcagroup.com/servizi/area-leasys.aspx"
					target="_blank"
				>
					{{ "bolli-pratiche.p6" | translate }}
				</a>
				<br />
				<br /> -->
				<p class="help-text">
					<strong>{{ "bolli-pratiche.p4" | translate }}</strong>
				</p>
				<p class="help-text">{{ "bolli-pratiche.p5" | translate }}</p>
				<p class="help-text">{{ "bolli-pratiche.p7" | translate }}</p>
				<a
					class="ck-link p-0"
					routerLink="/private/post-sales"
				>
					{{ "bolli-pratiche.p6" | translate }}
				</a>
			</mat-expansion-panel>
		}
	</mat-accordion>
</div>